/**
 * Perancangan Fasa 3 P3-7 (pelan P3-7 D-321): panel peraturan dan penentuannya, jadual pembangunan, nilai peraturan
 * dalam Tetapan dan kata-kata penolakan peraturan. Disebarkan melalui intake-ms.ts.
 */
export default {
  rules: {
    title: 'Peraturan perancangan',
    advisory:
      'Nasihat sahaja: keputusan ini membantu penilaian. Peraturan yang gagal atau memerlukan pegawai perlu ditentukan sebelum kes dibentangkan.',
    none: 'Peraturan belum dinilai bagi kes ini.',
    run: 'Nilai peraturan',
    rerun: 'Nilai semula',
    requested: 'Peraturan telah dinilai.',
    failed: 'Penilaian terakhir tidak dapat direkodkan: {{reason}}',
    meta: 'Semakan {{revision}}, dinilai pada {{date}}',
    packVersion: 'Set peraturan pek versi {{version}}',
    valuesChanged: 'Majlis telah mengubah nilai peraturannya selepas penilaian ini. Nilai semula untuk menggunakannya.',
    older: 'Penilaian ini bagi semakan {{revision}}; kes kini pada semakan {{current}}.',
    citation: '{{document}}, hlm. {{page}}',
    actualRequired: '{{actual}} (diperlukan: {{required}})',
    trigger: { staged: 'selepas semakan pelan', on_demand: 'atas permintaan' },
    status: {
      pass: 'Mematuhi peraturan',
      fail: 'Tidak mematuhi peraturan',
      needs_officer: 'Memerlukan pegawai',
      not_applicable: 'Tidak terpakai',
      not_configured: 'Tiada nilai majlis',
    },
    reasons: {
      slots_missing: 'Majlis belum memasukkan semua nilai yang dibaca oleh peraturan ini.',
      schedule_missing:
        'Tiada jadual pembangunan diisytiharkan, atau satu barisnya tidak menyatakan kuantiti yang dibaca oleh peraturan ini.',
      site_missing: 'Semakan ini tiada tapak dalam daftar.',
      flag_missing: 'Fakta kes yang dibaca oleh peraturan ini belum direkodkan.',
      zero_base: 'Asas pembahaginya adalah sifar.',
      lookup_missing: 'Majlis tiada nilai bagi jenis pembangunan yang diisytiharkan.',
      lookup_ambiguous: 'Lebih daripada satu jenis pembangunan diisytiharkan; pegawai menentukan nilai yang terpakai.',
      invalid_input: 'Nilai yang dibaca oleh peraturan ini bukan nombor.',
    },
    reportErrors: {
      register_rows_missing: 'semakan ini tiada baris daftar',
      superseded: 'semakan yang lebih baharu menggantikannya dahulu',
      rules_not_configured: 'tiada nilai peraturan dimasukkan',
      other: 'penilaian terhenti',
    },
    determinations: {
      title: 'Penentuan',
      open: '{{number}} menunggu penentuan',
      pending: 'Belum ditentukan',
      recorded: '{{outcome}}, direkodkan pada {{date}}',
      note: 'Catatan: {{note}}',
      record: 'Rekod',
      change: 'Ubah',
    },
    determine: {
      title: 'Penentuan: {{rule}}',
      intro: 'Rekodkan penentuan anda bagi peraturan ini. Keputusan kekal sebagai nasihat.',
      outcome: 'Keputusan',
      outcomeRequired: 'Pilih keputusan.',
      note: 'Catatan',
      noteHint: 'Pilihan. Pegawai dan jabatan majlis melihatnya; pemohon tidak.',
      replaces: 'Ini menggantikan penentuan yang direkodkan pada {{date}}.',
      confirm: 'Rekod',
      cancel: 'Batal',
      done: 'Penentuan telah direkodkan.',
    },
    outcomes: { complies: 'Mematuhi', acceptable: 'Boleh diterima', objection: 'Bantahan' },
    schedule: {
      title: 'Jadual pembangunan',
      intro: 'Apa yang diisytiharkan oleh pemohon tentang pembangunan. Peraturan perancangan membacanya.',
      none: 'Tiada jadual pembangunan diisytiharkan.',
      type: 'Jenis pembangunan',
      edit: 'Sunting jadual',
      add: 'Tambah baris',
      remove: 'Buang',
      removeLabel: 'Buang baris {{number}}',
      save: 'Simpan jadual',
      cancel: 'Batal',
      saved: 'Jadual telah disimpan.',
      typeRequired: 'Pilih jenis pembangunan bagi setiap baris.',
      notNumber: 'Masukkan nombor 0 atau lebih.',
      notWhole: 'Masukkan nombor bulat.',
      tooMany: 'Paling banyak {{max}} baris.',
      row: 'Baris {{number}}',
    },
    settings: {
      title: 'Peraturan perancangan',
      description:
        'Pek membekalkan struktur dan rujukan setiap set peraturan. Masukkan nilai majlis anda sendiri; set peraturan yang dibiarkan kosong tidak diguna pakai.',
      setsVersion: 'Set peraturan pek versi {{version}}',
      none: 'Pek tidak mengisytiharkan sebarang set peraturan.',
      adopted: 'Diguna pakai',
      notAdopted: 'Tidak diguna pakai',
      citationNoPage: '{{document}} (halaman akan disemak)',
      import: 'Import nilai (JSON)',
      export: 'Eksport nilai (JSON)',
      importFailed: 'Fail itu bukan eksport nilai peraturan.',
      imported: 'Nilai telah dimuatkan. Semak, kemudian simpan.',
      importDropped:
        'Nilai tidak dimuatkan: {{count}}. Versi pek ini tidak mengisytiharkannya, atau nilai itu tidak sesuai dengan medannya.',
      importVersion: 'Fail ini dieksport untuk versi set peraturan yang lain. Semak nilai sebelum menyimpan.',
      save: 'Simpan nilai peraturan',
      saving: 'Menyimpan…',
      saved: 'Nilai peraturan telah disimpan.',
      blocked: 'Sesetengah nilai tidak dapat disimpan. Betulkan item yang ditandakan di atas.',
      digest: 'Ringkasan nilai: {{digest}}',
      units: {
        m2: 'meter persegi',
        percent: 'peratus',
        count: 'bilangan',
        ratio: 'nisbah',
        per_hectare: 'sehektar',
      },
      bands: {
        upTo: 'Sehingga',
        open: 'dan ke atas',
        per: 'Satu bagi setiap',
        add: 'Tambah jalur',
        remove: 'Buang jalur {{number}}',
      },
      table: { type: 'Jenis pembangunan', value: 'Nilai' },
      references: {
        title: 'Jenis pembangunan dan rujukan anda',
        hint: 'Pilihan: rujukan majlis anda sendiri bagi setiap jenis, seperti seksyen garis panduan. Ia disimpan di sini bersama nilai peraturan anda dan dieksport bersamanya.',
        label: 'Rujukan bagi {{type}}',
      },
      problems: {
        notNumber: 'Masukkan nombor 0 atau lebih.',
        notPercent: 'Masukkan bahagian dari 0 hingga 100.',
        bands: 'Jalur meningkat, setiap satu dengan kadar melebihi 0; hanya jalur terakhir boleh tanpa had.',
        table: 'Masukkan nombor 0 atau lebih.',
        reference: 'Paling banyak 120 aksara.',
        tooLarge: 'Paling banyak 1,000,000,000.',
        tooManyBands: 'Paling banyak 20 jalur.',
      },
    },
  },
  errors: {
    rules_not_configured:
      'Tiada nilai peraturan dimasukkan bagi majlis ini. Pentadbir memasukkannya dalam Tetapan → Perancangan.',
    rule_report_not_found: 'Penilaian peraturan itu bukan bagi kes ini.',
    rule_report_not_done: 'Penilaian peraturan itu tidak selesai. Muat semula halaman dan cuba lagi.',
    rule_report_superseded: 'Penilaian peraturan yang lebih baharu menggantikannya. Muat semula halaman dan cuba lagi.',
    rule_report_changed: 'Penilaian peraturan itu berubah sejak halaman dimuatkan. Muat semula halaman dan cuba lagi.',
    rule_not_determinable: 'Peraturan itu tidak memerlukan penentuan dalam penilaian ini.',
  },
} as const
